// =============================================================================
//  CONTEÚDO DO MODO RELACIONAL — "A Bússola do Encontro"
//  "O Coração de Todas as Coisas" — por Magan
//  Espelho para a conversa de duas pessoas — nunca um índice de compatibilidade.
//  Placeholders: {A} {B} {forte} {fraco} {de} {para}
// =============================================================================

// ---- Estações que vocês compartilham (ambos fortes na mesma raiz) ----
export const ENCONTRO_RAIZ = {
  peregrino:'Vocês dois gostam de movimento, de mudança e de novos começos. São companheiros de estrada: entendem a vontade de explorar um do outro. O cuidado é lembrar de também parar e curtir o que já construíram juntos.',
  guardiao:'Vocês dois valorizam segurança, rotina e um lar estável. Isso cria uma base forte entre vocês. O cuidado é não deixar a estabilidade virar comodismo: de vez em quando, experimentem coisas novas juntos.',
  amante:'Vocês dois vivem intensamente o afeto e a conexão. É lindo amar com a mesma intensidade. O cuidado é manter a individualidade de cada um: podem ser dois e ainda serem inteiros.',
  alquimista:'Vocês dois buscam sentido nas coisas e gostam de conversas profundas. Isso une vocês. O cuidado é também curtir o simples, o leve, sem precisar analisar tudo.',
};

// ---- Onde se complementam (um forte onde o outro é silencioso) ----
export const COMPLEMENTO_RAIZ = {
  peregrino:'{forte} tem mais energia para mudanças, enquanto {fraco} prefere estabilidade. {forte} pode inspirar {fraco} a se aventurar mais; {fraco} pode ajudar {forte} a apreciar o momento presente. Um traz movimento, o outro traz raiz.',
  guardiao:'{forte} traz mais estrutura e organização, onde {fraco} é mais flexível. {forte} pode oferecer segurança a {fraco}; {fraco} pode lembrar {forte} que nem tudo precisa ser controlado. Um traz a base, o outro traz leveza.',
  amante:'{forte} expressa mais o afeto, enquanto {fraco} é mais reservado(a). {forte} pode ajudar {fraco} a se abrir mais; {fraco} pode mostrar a {forte} que amor também se demonstra de formas quietas. O importante é não confundir reserva com falta de amor.',
  alquimista:'{forte} busca mais significado nas coisas, enquanto {fraco} prefere o prático. {forte} pode trazer profundidade à relação; {fraco} pode trazer {forte} de volta ao presente. Juntos, unem sonho e realidade.',
};

// ---- A tensão do casal (raízes dominantes diferentes — 6 pares) ----
export const TENSAO_CASAL = {
  'guardiao__peregrino':'A tensão entre vocês é entre ficar e partir: um quer estabilidade, o outro quer novidade. Não é problema — é oportunidade. Combinem: aventuras que cabem numa vida estável, e rotinas que deixam espaço para o novo.',
  'amante__peregrino':'Um de vocês quer proximidade, o outro quer espaço. Liberdade e vínculo podem conviver: combinem momentos de conexão intensa com momentos de autonomia para cada um.',
  'alquimista__peregrino':'Um quer entender tudo, o outro quer seguir em frente. Juntos podem ter visão e ação: quem reflete ajuda a dar direção, quem age ajuda a sair do lugar.',
  'amante__guardiao':'Um transborda sentimento, o outro organiza e estrutura. O afeto de um precisa da organização do outro para não se perder — e a estrutura precisa do calor para não ficar fria.',
  'alquimista__guardiao':'Um quer transformar, o outro quer manter. É uma tensão muito fértil: juntos podem construir coisas que duram e que têm significado.',
  'alquimista__amante':'Um vive pelo coração, o outro busca entender. Quando se escutam, criam algo bonito juntos. O cuidado é não julgar: quem sente não é "demais", quem pensa não é "frio".',
};

// ---- Como cuidar um do outro (pista por estação) ----
export const CUIDADO_PISTA = {
  peregrino:'propor algo novo de vez em quando — um passeio diferente, uma mudança pequena na rotina',
  guardiao:'oferecer segurança e descanso — preparar algo, cuidar de detalhes, mostrar que pode confiar',
  amante:'demonstrar afeto com palavras e gestos — dizer o que sente, estar presente de verdade',
  alquimista:'criar espaço para conversas mais profundas — perguntar como está se sentindo, dar tempo para reflexão',
};

// ---- O que cada um pode ensinar ao outro (para cuidado recíproco) ----
export const CUIDADO_RECIPROCO = {
  peregrino: {
    oferece: 'energia para mudanças e novidades',
    recebe: 'ajuda para apreciar o que já tem'
  },
  guardiao: {
    oferece: 'estabilidade e cuidado prático',
    recebe: 'convites para flexibilizar e experimentar'
  },
  amante: {
    oferece: 'afeto, presença e conexão emocional',
    recebe: 'espaço para ser inteiro além da relação'
  },
  alquimista: {
    oferece: 'profundidade e busca de sentido',
    recebe: 'leveza e presença no momento'
  }
};

// ---- NOVO: Pontos fortes do casal (baseado na estação mais forte de cada um) ----
export const PONTOS_FORTES_CASAL = {
  peregrino: 'Vocês têm a capacidade de se reinventar, de não ficarem presos ao passado. Quando algo não funciona, sabem mudar de direção.',
  guardiao: 'Vocês constroem coisas que duram. Há uma solidez entre vocês que dá segurança para os dois.',
  amante: 'Vocês sabem cuidar um do outro com carinho. O afeto entre vocês é visível e nutre a relação.',
  alquimista: 'Vocês conseguem dar sentido ao que vivem juntos. Transformam até as dificuldades em aprendizado.',
};

// ---- NOVO: O que o casal precisa desenvolver (baseado na estação mais fraca) ----
export const DESENVOLVER_JUNTOS = {
  peregrino: 'Experimentar mais coisas novas juntos. A rotina pode ser confortável, mas vocês também precisam de aventura.',
  guardiao: 'Criar mais rituais e rotinas de cuidado. Às vezes a relação precisa de estrutura para florescer.',
  amante: 'Expressar mais o que sentem um pelo outro. O amor existe, mas precisa ser dito e demonstrado.',
  alquimista: 'Conversar sobre o que realmente importa. Às vezes vocês ficam na superfície — mergulhem mais fundo.',
};

// ---- NOVO: Práticas para o casal ----
export const PRATICAS_CASAL = {
  peregrino: 'Uma vez por mês, façam algo que nunca fizeram juntos. Pode ser pequeno: um restaurante novo, um caminho diferente, um hobby compartilhado.',
  guardiao: 'Criem um ritual só de vocês — um café da manhã no domingo, uma caminhada semanal, um momento de silêncio juntos.',
  amante: 'Toda semana, digam um ao outro algo que admiram ou agradecem. Parece simples, mas muda tudo.',
  alquimista: 'De vez em quando, sentem e conversem sobre vocês: como estão, o que querem, o que mudou. Sem pressa.',
};

// ---- NOVO: Linguagem do amor do casal (baseado nas estações dominantes) ----
export const LINGUAGEM_CASAL = {
  peregrino: { 
    linguagem: 'Liberdade e Companheirismo',
    descricao: 'Vocês se amam dando espaço um ao outro e compartilhando aventuras. O amor de vocês é movimento.'
  },
  guardiao: { 
    linguagem: 'Cuidado e Presença',
    descricao: 'Vocês se amam através de gestos práticos e presença constante. O amor de vocês é porto seguro.'
  },
  amante: { 
    linguagem: 'Afeto e Conexão',
    descricao: 'Vocês se amam intensamente, com palavras e toques. O amor de vocês é calor.'
  },
  alquimista: { 
    linguagem: 'Profundidade e Sentido',
    descricao: 'Vocês se amam buscando entender um ao outro. O amor de vocês é conversa.'
  },
};

// ---- NOVO: Riscos do casal (o que pode dar errado se não cuidarem) ----
export const RISCOS_CASAL = {
  'guardiao__peregrino': 'O risco é um se sentir preso e o outro abandonado. Negociem o ritmo de vocês.',
  'amante__peregrino': 'O risco é um sufocar e o outro fugir. Dosar proximidade e espaço é a chave.',
  'alquimista__peregrino': 'O risco é um achar o outro superficial e vice-versa. Respeitem os tempos diferentes.',
  'amante__guardiao': 'O risco é um achar o outro frio e o outro achar um intenso demais. Traduzam suas linguagens.',
  'alquimista__guardiao': 'O risco é um achar o outro parado e o outro achar um "viajando". Equilibrem sonho e ação.',
  'alquimista__amante': 'O risco é um racionalizar o que o outro sente. Nem tudo precisa de explicação.',
};

// ---- NOVO: Perguntas provocativas para o casal (reflexão sobre o relacionamento) ----
export const PERGUNTAS_CASAL = {
  peregrino: 'Quando foi a última vez que vocês fizeram algo pela primeira vez juntos?',
  guardiao: 'O que vocês têm construído juntos que vai durar mais que vocês?',
  amante: 'Vocês ainda se olham como se olhavam no começo?',
  alquimista: 'O que a vida já ensinou vocês que só poderiam aprender juntos?',
};

// ---- NOVO: Como um espelha o outro (reflexo mútuo) ----
export const ESPELHO_CASAL = {
  peregrino: {
    titulo: 'O Movimento entre vocês',
    texto: 'Um convida o outro a sair do lugar. Quando um para, o outro puxa. Quando um acelera demais, o outro ancora. Vocês se equilibram no ritmo.'
  },
  guardiao: {
    titulo: 'A Raiz entre vocês', 
    texto: 'Um oferece chão ao outro. Há uma segurança silenciosa entre vocês — um lugar para voltar quando o mundo pesa. Isso é raro.'
  },
  amante: {
    titulo: 'O Vínculo entre vocês',
    texto: 'Um aquece o outro. Há uma presença que não precisa de palavras. O afeto de vocês não é só sentido — é percebido por quem está perto.'
  },
  alquimista: {
    titulo: 'O Sentido entre vocês',
    texto: 'Um ajuda o outro a entender o que vive. Vocês transformam experiências em aprendizado juntos. A dor compartilhada pesa menos.'
  },
};

// ---- NOVO: O que um ensina ao outro ----
export const ENSINO_MUTUO = {
  peregrino: '{A} pode ensinar {B} a se arriscar mais. {B} pode ensinar {A} a valorizar o que já tem.',
  guardiao: '{A} pode ensinar {B} a criar raízes. {B} pode ensinar {A} a soltar o controle às vezes.',
  amante: '{A} pode ensinar {B} a se abrir mais. {B} pode ensinar {A} que o amor não precisa de palavras sempre.',
  alquimista: '{A} pode ensinar {B} a encontrar sentido. {B} pode ensinar {A} que nem tudo precisa de explicação.',
};

// ---- NOVO: Insight do livro (opcional, só para quem quer ir mais fundo) ----
export const INSIGHT_LIVRO = {
  peregrino: '"O Peregrino não foge — ele busca. A diferença é sutil, mas muda tudo." — Cap. 3',
  guardiao: '"O Guardião sabe que não existe liberdade sem um lugar para voltar." — Cap. 1',
  amante: '"O Amante não se perde no outro — ele se encontra." — Cap. 3',
  alquimista: '"O Alquimista não nega a dor — ele pergunta o que ela veio ensinar." — Cap. 5',
};

export const ROOT_LABEL = { peregrino:'Movimento', guardiao:'Raiz', amante:'Vínculo', alquimista:'Sentido' };
export const ROOT_NOME = { peregrino:'Peregrino', guardiao:'Guardião', amante:'Amante', alquimista:'Alquimista' };

// ---- Capítulo do livro para o casal (pela estação que pede cuidado em comum) ----
export const CAP_ENCONTRO = {
  peregrino:{ capitulo:'Capítulo 3 — Águas Cristalinas', promessa:'Sobre caminhar leve — para vocês se aventurarem juntos.' },
  guardiao:{ capitulo:'Capítulo 1 — Para você viver mais', promessa:'Sobre presença e cuidado — para construírem uma base segura.' },
  amante:{ capitulo:'Capítulo 3 — O Coração Amanhece', promessa:'Sobre abrir o coração — para quando o vínculo pede mais atenção.' },
  alquimista:{ capitulo:'Capítulo 5 — O Jardim do Perdão', promessa:'Sobre soltar o peso — para transformarem juntos o que viveram.' },
};
export const CAP_VINCULO = { capitulo:'Capítulo 6 — Lembre-se de Mim', promessa:'Para celebrar o encontro de vocês.' };

// ---- Frase-semente do encontro (por padrão dominante) ----
export const SEMENTE_ENCONTRO = {
  encontro:'Caminhamos juntos porque nosso coração fala a mesma língua.',
  complemento:'O que falta em mim, você tem. O que falta em você, eu tenho.',
  tensao:'Somos diferentes — e é isso que nos faz crescer juntos.',
  equilibrio:'Dois inteiros que escolheram se encontrar.',
};

export default { 
  ENCONTRO_RAIZ, COMPLEMENTO_RAIZ, TENSAO_CASAL, CUIDADO_PISTA, CUIDADO_RECIPROCO, 
  PONTOS_FORTES_CASAL, DESENVOLVER_JUNTOS, PRATICAS_CASAL, LINGUAGEM_CASAL, RISCOS_CASAL,
  PERGUNTAS_CASAL, ESPELHO_CASAL, ENSINO_MUTUO, INSIGHT_LIVRO,
  ROOT_LABEL, ROOT_NOME, CAP_ENCONTRO, CAP_VINCULO, SEMENTE_ENCONTRO 
};
